/*
 * Filter Multi - A Kew Green Special Edition
 * for filtering elements with multiple categories each
 */
$(document).ready(function() {
    $('[data-filter-multi]').each(function() {
        var $_filterElement = $(this);
        var $_filterItems = $_filterElement.find('.' + $_filterElement.data('filter-class'));

        var $_filterTextAll = $_filterElement.data('filter-all') || 'All';

        var $_filterAllLast = $_filterElement.data('filter-all-last') || false;

        // Step 1: assemble a full list of each
        var filterCategories = {};
        $_filterItems.each(function() {
            var itemFilterCategories = $(this).data('filter-categories');
            
            if ( (typeof itemFilterCategories !== 'undefined') && (itemFilterCategories !== '') ) {
                // Loop through each category set on this item
                for (var categoryName in itemFilterCategories) {                    
                    // Check to see if this exists in our list yet
                    if (checkCategoryExists(categoryName, filterCategories)) {
                        // Yes, so add these items to the list
                        filterCategories[categoryName] = filterCategories[categoryName].concat( itemFilterCategories[categoryName] );
                    } else {
                        // No, so make a new entry and add these items
                        filterCategories[categoryName] = itemFilterCategories[categoryName];
                    }
                }   
            }
        });

        // Now remove all the duplicate array items
        for (var categoryName in filterCategories) {
            filterCategories[categoryName] = unique( filterCategories[categoryName] );
        }

        //console.table( filterCategories );


        



        // Step 2: create the filter buttons
        var buttonClass = '';

        var filterAllButton = '<button class="button all ' + (!$_filterAllLast ? 'on ' : '') + buttonClass + '">' + $_filterTextAll + '</button>';

        var filterButtons = '';

        if (!$_filterAllLast) {
            filterButtons += filterAllButton;
        }

        var firstFilterButtonActive = $_filterAllLast;
        var filterCategoryCount = 0;
        
        for ( var categoryName in filterCategories ) {
            filterButtons += '<div class="filter__select"><select name="' + categoryName + '"><option value="all">' + categoryName + '</option>';
            
            for ( var categoryItem in filterCategories[categoryName] ) {
                filterButtons += '<option>' + filterCategories[categoryName][categoryItem] + '</option>';
            }
            
            filterButtons += '</select></div>';
            filterCategoryCount++;
        }
        
        // No categories have been set on any of the filter elements, so hide the filter div and end
        if ( filterCategoryCount === 0 ) {
            $_filterElement.find('.' + $_filterElement.data('filter-controls')).remove();
            return;
        }
        
        if ($_filterAllLast) {
            filterButtons += filterAllButton;
        }

        $_filterElement.find('.' + $_filterElement.data('filter-controls')).append(filterButtons);

        
       
        
        
        
        
        

        // Step 3: set up the button events
        var $_filterAllButton = $_filterElement.find('.' + $_filterElement.data('filter-controls')).find('button.all');
        var $_filterSelectDropdowns = $_filterElement.find('.' + $_filterElement.data('filter-controls')).find('select');
        
        // The "All" button
        $_filterAllButton.on('click', function () {
            // Set all button and dropdown states
            $(this).addClass('on');
            $_filterSelectDropdowns.val('all');
            
            // Show everything and trigger event
            $_filterItems.fadeIn();
            $_filterElement.trigger('filter-changed', null).removeClass('filter-multi-filtered');
        });
        
        // The category dropdown menus
        $_filterSelectDropdowns.on('change', function() {
            if ( atLeastOneFilterIsSet( $_filterSelectDropdowns ) ) {
                // At least one filter picked, so filter the elements
                $_filterAllButton.removeClass('on');
                
                // Make a list of the selected filters
                var selectedFilters = {};
                $_filterSelectDropdowns.each(function () {
                    if ( $(this).val() !== 'all' ) {
                       //selectedFilters.push( $(this).val() );
                       
                       selectedFilters[$(this).attr('name')] = $(this).val();
                    } 
                });
                
                // Loop through every item and see if it matches our list
                $_filterItems.each(function () {
                    var itemFilterCategories = $(this).data('filter-categories');
                    if ( (typeof itemFilterCategories !== 'undefined') && (itemFilterCategories !== '') ) {
                        if ( itemMatchesSelectedCategories(itemFilterCategories, selectedFilters) ) {
                            //console.log('y');
                            $(this).fadeIn().addClass('filter-multi-item-visible');
                        } else {
                            //console.log('n');
                            $(this).fadeOut().removeClass('filter-multi-item-visible');
                        }
                    }
                });
                
                
                // Trigger event to allow other JS to interact with the filter change
                $_filterElement.trigger('filter-changed', null).addClass('filter-multi-filtered');
                
            } else {
                // Dropdowns have all been set to "All"
                $_filterAllButton.addClass('on');
                
                // Show everything and trigger event
                $_filterItems.fadeIn().addClass('filter-multi-item-visible');
                $_filterElement.trigger('filter-changed', null).removeClass('filter-multi-filtered');
            }
        });
        
        

        // if not showing All, initialise the selected filter
        if ($_filterAllLast) {
            $_filterButtons.first(':is(.on)').trigger('click');
        }
    });
});

// Filter a list to only unique values
// https://stackoverflow.com/questions/12551635/jquery-remove-duplicates-from-an-array-of-strings
function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}


function checkCategoryExists(needle, haystack) {
    for (i in haystack) {
        if (i === needle) return true;
    }
    return false;
}


function atLeastOneFilterIsSet(selectsToCheck) {
    var unsetCount = 0;
    $(selectsToCheck).each(function () {
        if ( $(this).val() !== 'all' ) {
            unsetCount++;
        }
    });
    
    if ( unsetCount > 0 ) {
        return true;
    } else {
        return false;
    }
}


function itemMatchesSelectedCategories(itemFilterCategories, selectedFilters) {
    //console.log(itemFilterCategories, selectedFilters);
    
    var selectedFilterCount = 0;
    var matchingFilterCount = 0;
    
    for (var singleSelectedFilter in selectedFilters) {
        selectedFilterCount++;
        
        //console.log( itemFilterCategories[singleSelectedFilter], selectedFilters[singleSelectedFilter] );
        //console.log( itemFilterCategories[singleSelectedFilter].indexOf( selectedFilters[singleSelectedFilter] ) );
        
        if ( typeof  itemFilterCategories[singleSelectedFilter] !== 'undefined' ) {
            if ( itemFilterCategories[singleSelectedFilter].indexOf( selectedFilters[singleSelectedFilter] ) > -1 ) {
                matchingFilterCount++;
            }
        }
    }
    
    //console.log(matchingFilterCount , selectedFilterCount);
    
    if (matchingFilterCount === selectedFilterCount) {
        return true;
    } else {
        return false;
    }
}
